import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom, from, race, timer } from 'rxjs';
import { OtpRefreshService } from './otp-refresh.service';
import { TokenStorageService } from './token-storage.service';

// endSession() waits for the cross-tab refresh lock; a lock that is never released must not keep
// the user on the logout route.
const END_SESSION_TIMEOUT_MS = 5_000;

export const logoutGuard: CanActivateFn = () => {
  const tokenStorage = inject(TokenStorageService);
  const router = inject(Router);
  if (tokenStorage.hasSession()) {
    const endSession = from(inject(OtpRefreshService).endSession());
    return firstValueFrom(race(endSession, timer(END_SESSION_TIMEOUT_MS)))
      .catch(() => undefined)
      .then(() => {
        tokenStorage.clear();
        return router.createUrlTree(['/login']);
      });
  }
  tokenStorage.clear();
  const msalService = inject(MsalService);
  if (msalService.instance.getAllAccounts().length > 0) {
    msalService.logoutRedirect({
      postLogoutRedirectUri: `${window.location.origin}/login`,
    });
    return false;
  }
  return router.createUrlTree(['/login']);
};
